import type { TAttributeOptionDto } from '@homepal/api-contract'
import { getWithRedirect } from 'utils/axios'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/attribute-options`

// The endpoint returns a flat list; the reducer groups it by
// fact_table_id itself.
export async function getAll() {
  return getWithRedirect<TAttributeOptionDto[]>(URL)
}
